export function clickDeny ({uid, name}) {
  const body = {
    'App Name': name,
    'App ID': uid
  }
  const eventName = 'Apps Permission Deny Click'
  mixpanel.track(eventName, body)
  clevertap.event.push(eventName, body)
}

export function clickTryAgain ({uid, name}) {
  const body = {
    'App Name': name,
    'App ID': uid
  }
  const eventName = 'Apps Permission Deny Try Again'
  mixpanel.track(eventName, body)
  clevertap.event.push(eventName, body)
}

export function clickCancel (_, callback) {
  let args = [{}] // argument parameter included in the mixpanel
  if (callback) {
    args.push(callback)
  }
  const eventName = 'Apps Permission Deny Confirmed'
  clevertap.event.push(eventName)
  mixpanel.track(eventName, ...args)
}

export function clickAllow ({uid, name}) {
  const body = {
    'App Name': name,
    'App ID': uid
  }
  const eventName = 'Apps Permission Allow'
  clevertap.event.push(eventName, body)
  mixpanel.track(eventName, body)
}

export function policy () {
  const eventName = 'Apps Permission Policy'
  clevertap.event.push(eventName)
  mixpanel.track(eventName)
}



// WEBPACK FOOTER //
// app/javascript/components/mixpanel/frags/authorizationModal.js